export default "/images/vendor/flag-icons/flags/4x3/kn.svg?63c3ea5ba9e186d6534626aa3f3a8332";